// broadcastSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IDeleteTemplateModal {
  selectedTemplateId: any;
  selectedTemplateName: any;
  visible: boolean;
}

export interface IDeleteScheduleModal {
  selectedScheduleId: any;
  selectedScheduleName: any;
  visible: boolean;
}

export const initialStateDeleteTemplateModal: IDeleteTemplateModal = {
  selectedTemplateId: '',
  selectedTemplateName: '',
  visible: false
}

export const initialStateScheduleModal: IDeleteScheduleModal = {
  selectedScheduleId: '',
  selectedScheduleName: '',
  visible: false
}
const broadcastSlice = createSlice({
  name: 'broadcast',
  initialState: {
    broadcastName: '',
    broadcastId: '',
    deleteRecipientModal: false,
    deleteTemplateModal: initialStateDeleteTemplateModal,
    deleteScheduleModal: initialStateScheduleModal,
    addScheduleModal: false,
    addTemplateModal: false,
    editTemplateModal: false,
    editScheduleModal: false,
    detailTemplate: {},
    detailSchedule: {}
  },
  reducers: {
    setBroadcastId: (state, action: PayloadAction<string>) => {
      state.broadcastId = action.payload;
    },
    setDeleteRecipientModal: (state, action: PayloadAction<boolean>) => {
      state.deleteRecipientModal = action.payload;
    },
    setDeleteTemplateModal: (state, action: PayloadAction<IDeleteTemplateModal>) => {
      state.deleteTemplateModal = action.payload;
    },
    setDeleteScheduleModal: (state, action: PayloadAction<IDeleteScheduleModal>) => {
      state.deleteScheduleModal = action.payload;
    },
    setAddScheduleModal: (state, action: PayloadAction<boolean>) => {
      state.addScheduleModal = action.payload;
    },
    setAddTemplateModal: (state, action: PayloadAction<boolean>) => {
      state.addTemplateModal = action.payload;
    },
    setEditTemplateModal: (state, action: PayloadAction<boolean>) => {
      state.editTemplateModal = action.payload;
    },
    setEditScheduleModal: (state, action: PayloadAction<boolean>) => {
      state.editScheduleModal = action.payload;
    },
    setDetailTemplateAction: (state, action: PayloadAction<any>) => {
      state.detailTemplate = action.payload;
    },
    setDetailScheduleAction: (state, action: PayloadAction<any>) => {
      state.detailSchedule = action.payload;
    }
  },
});

export const { 
  setBroadcastId, setDeleteRecipientModal, setDeleteScheduleModal, setDeleteTemplateModal, setAddScheduleModal, setAddTemplateModal, setEditTemplateModal, setDetailTemplateAction, setEditScheduleModal, setDetailScheduleAction } = broadcastSlice.actions;

export default broadcastSlice.reducer;
